import flatten from 'lodash/flatten'

import { FormTypeId } from '~/common/constants/formTypes'
import configs from '~/form/configs'

import { FormPropsName } from '../types'

import displayNameValidator from './displayNameValidator'
import getNames from './getNames'

const namesComposer = (formTypeId: FormTypeId) => {
  const config = configs[formTypeId]
  if (!config) return []
  const names = config
    .map((c) => {
      return displayNameValidator(c.component)
    })
    .map(getNames)

  return flatten(names) as FormPropsName[]
}

export default namesComposer
